export default {
  metadata: {
    version: '1.0.0',
    id: 'modal-desktop-1.0.0',
    name: 'JDSModalDesktop',
    platform: 'web',
    description:
      'Modals focus the user’s attention exclusively on one task or piece of information via a window that sits on top of the page content. Dialog Modals are used to confirm with the user before continuing with destructive or complex actions. In this case the modal have two buttons at the bottom. Access to the rest of the UI is disabled until the modal is addressed.',
    usage:
      'A dialog modal uses two buttons and requires immediate user response.'
  },
  hierarchy: {
    popup: [
      {
        'popup-container': ['jds_modal_desktop_internal']
      }
    ]
  },
  base: {
    popup: {
      priority: 60,
      'full-width': true,
      passive: true
    },
    'popup-container': {
      'flex-direction': '{m_0}',
      'justify-content': '{m_1}',
      'align-items': '{m_2}',
      size: '{m_3}',
      'enter-animation-name': 'fadeIn',
      'exit-animation-name': 'fadeOut',
      'enter-animation-curve': 'entrance_ease',
      'exit-animation-curve': 'exit_ease',
      'enter-animation-duration': 500,
      'exit-animation-duration': 500,
      opacity: '{opacity.invisible}',
      transition: {
        property: ['opacity'],
        duration: '{medium}',
        'timing-function': '{easeEntrance}'
      }
    },
    jds_modal_desktop_internal: {
      kind: 'dialog',
      headerAlignment: 'left',
      isCloseable: true,
      size: 'medium'
    }
  },
  variant: {
    kind: {
      acknowledgement: {
        jds_modal_desktop_internal: {
          kind: 'acknowledgement'
        }
      },
      informational: {
        jds_modal_desktop_internal: {
          kind: 'informational'
        }
      },
      custom: {
        jds_modal_desktop_internal: {
          kind: 'custom'
        }
      }
    },
    headerAlignment: {
      right: {
        jds_modal_desktop_internal: {
          headerAlignment: 'right'
        }
      },
      center: {
        jds_modal_desktop_internal: {
          headerAlignment: 'center'
        }
      }
    },
    size: {
      small: {
        jds_modal_desktop_internal: {
          size: 'small'
        }
      }
    },
    close: {
      false: {
        popup: {
          hidden: false,
          passive: false
        },
        'popup-container': {
          opacity: '{opacity.enabled}',
          transition: {
            'timing-function': '{easeExit}'
          }
        }
      }
    },
    isCloseable: {
      false: {
        jds_modal_desktop_internal: {
          isCloseable: false
        }
      }
    }
  },
  api: {
    config: {
      kind: {
        values: ['dialog', 'acknowledgement', 'informational', 'custom'],
        doc_description:
          'It can be used to switch between 3 variants of Modal. `informational` modal has no buttons,`dialog` modal has two buttons, `acknowledgement` modal has only a single button.'
      },
      size: {
        values: ['medium', 'small'],
        doc_description:
          'It can be used to control the size of popup container.'
      },
      headerAlignment: {
        values: ['left', 'right', 'center'],
        doc_description: 'It is used to align header of Modal.'
      },
      isCloseable: {
        values: [true, false],
        doc_description:
          'It can be used to makes Modal closeable, displays close icon button on popup.'
      },
      close: {
        values: [true, false],
        doc_description: 'It is used to close the Modal.'
      },
      _platform: {
        values: ['desktop', 'tablet']
      }
    },
    data: {
      jds_modal_desktop_internal: {
        header: {
          type: 'string',
          name: 'header',
          doc_description: 'It displays the title of modal.'
        },
        primaryCTA: {
          type: 'string',
          name: 'primaryCTA',
          doc_description: 'It displays label of primary button of Modal.'
        },
        primaryCtaDisabled: {
          type: 'boolean',
          name: 'primaryCtaDisabled'
        },
        secondaryCTA: {
          type: 'string',
          name: 'secondaryCTA',
          doc_description: 'It displays label of secondary button of Modal.'
        },
        secondaryCtaDisabled: {
          type: 'boolean',
          name: 'secondaryCtaDisabled'
        },
        children: {
          name: 'children',
          type: 'slot',
          doc_description:
            'This sets Modal content as a children elements eg. `<Modal> <Table /> <Modal/>`'
        }
      }
    },
    events: {
      popup: {
        onClick: 'onClose'
      },
      jds_modal_desktop_internal: {
        onModalClick: '_onModalClick',
        onCancel: '_onCancel',
        onPrimaryClick: 'onPrimaryClick',
        onSecondaryClick: 'onSecondaryClick'
      }
    },
    a11y: {
      jds_modal_desktop_internal: {
        properties: {
          ariaLabel: 'ariaLabel',
          ariaDescribedby: {
            name: 'ariaDescribedby',
            platform: 'web,ios'
          },
          cancelButtonCtaAriaLabel: 'cancelButtonCtaAriaLabel',
          primaryCtaAriaLabel: 'primaryCtaAriaLabel',
          primaryCtaAriaDescribedby: {
            name: 'primaryCtaAriaDescribedby',
            platform: 'web,ios'
          },
          secondaryCtaAriaLabel: 'secondaryCtaAriaLabel',
          secondaryCtaAriaDescribedby: {
            name: 'secondaryCtaAriaDescribedby',
            platform: 'web,ios'
          }
        }
      }
    }
  }
};
